<coin-v2-dialog-frame [header]="data?.headerTranslateKey ?? 'general.edit' | translate">
  <div class="body-container">
    <coin-v2-text-input
      matFormFieldClass="shadow"
      required
      [label]="'general.title-label' | translate"
      [placeholder]="'season-overview.dialog.title-placeholder' | translate"
      [disabled]="data.readonly || this.isDeleteUpdateDisabled"
      [(ngModel)]="plan.title" />
    @if (data?.showDescription) {
      <coin-v2-text-area
        class="admin-form-field-outline admin-form-field-outline--shadow admin-form-field-outline--dynamic-height"
        [disabled]="data.readonly"
        [label]="data.descriptionLabel ? (data.descriptionLabel | translate) : ('general.description' | translate)"
        [(ngModel)]="plan.description" />
    }
    @if (showDisplayName) {
      <coin-v2-text-input
        matFormFieldClass="shadow"
        [label]="'general.display-name' | translate"
        [placeholder]="'season-mgmt.display-name-placeholder' | translate"
        [(ngModel)]="plan.displayName" />
    }
  </div>
  <coin-v2-dialog-footer color="white">
    <coin-v2-button
      type="outline"
      icon="close"
      iconPos="right"
      [text]="'general.btnClose' | translate"
      (click)="close()"></coin-v2-button>
    @if (data?.plan && !data?.withoutDelete) {
      <coin-v2-button
        type="secondary"
        icon="delete"
        iconPos="right"
        [disabled]="data.readonly || this.isDeleteUpdateDisabled"
        [text]="'general.btnDelete' | translate"
        (click)="delete()"></coin-v2-button>
    }
    @if (data?.plan) {
      <coin-v2-button
        type="primary"
        icon="save"
        iconPos="right"
        [disabled]="!isValid || !hasChanges || data.readonly || this.isDeleteUpdateDisabled"
        [text]="data?.actionButtonTranslateKey || 'general.btnUpdate' | translate"
        (click)="update()"></coin-v2-button>
    }
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
